import { KeyboardArrowDown } from '@mui/icons-material';
import { ClickAwayListener, InputAdornment, Popper, styled, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { DropdownStoreItem } from './Item';
import { SearchSVG } from 'assets/img';
import { useQuery } from 'react-query';
import { getNewDataNonMaster } from 'api/masterStore';

const DropdownStoresStyle = styled('button')(() => ({
  backgroundColor: '#fff',
  padding: '8px 12px',
  border: '1px solid #ccc',
  borderRadius: '8px',
  cursor: 'pointer',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  fontSize: '14px',
  color: '#333',
  rowGap: '10px',
  minWidth: '180px'
}));

export const DropdownStoreRoot = ({ masterStoreId, handleSelectedStore }) => {
  const anchorEl = React.useRef<HTMLButtonElement | null>(null);
  const [open, setOpen] = React.useState<boolean>(false);
  const [searchStore, setSearchStore] = useState('');
  const [selected, setSelected] = React.useState(null);

  const FilSearchStore = (options) => {
    return options?.filter((opt) => {
      return opt.store_name?.toLowerCase().includes(searchStore.toLowerCase());
    });
  };

  const { data: stores } = useQuery({
    queryKey: ['master-stores'],
    queryFn: () => getNewDataNonMaster(),
    select: (res) => {
      const excludeMaster = res?.data?.data?.filter(
        (val) => Number(val.store_id) !== masterStoreId && val.channel_id !== 1
      );
      let newRes = excludeMaster.map((val) => ({
        store_name: val.store_name,
        store_id: val.store_id,
        channel_id: val.channel_id,
        is_downloaded: val.is_downloaded,
        total_downloaded: val.total_downloaded,
        all_product: val.all_product,
        on_download_process: val.on_download_process
      }));
      // soert newRes by is_downloaded descending
      newRes.sort((a, b) => {
        return Number(b.is_downloaded) - Number(a.is_downloaded);
      });
      return newRes;
    },
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled: Boolean(masterStoreId)
  });

  useEffect(() => {
    if (selected) {
      handleSelectedStore(selected);
    }
  }, [selected]);

  return (
    <div>
      <DropdownStoresStyle ref={anchorEl} onClick={() => setOpen(!open)} aria-haspopup="true" aria-expanded={open}>
        <DropdownStoreItem item={(selected as any) || null} />
        <KeyboardArrowDown />
      </DropdownStoresStyle>
      <Popper
        open={open}
        anchorEl={anchorEl.current}
        placement="bottom-end"
        style={{ zIndex: 1300 }}
        modifiers={[
          {
            name: 'offset',
            options: {
              offset: [48, 10]
            }
          }
        ]}
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={() => setOpen(false)}>
            <div
              {...TransitionProps}
              style={{
                border: '1px solid #ccc',
                borderRadius: '8px',
                backgroundColor: '#fff',
                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                padding: '10px',
                minWidth: '300px'
              }}
            >
              <div>
                <TextField
                  size="small"
                  variant="standard"
                  placeholder="Cari toko"
                  value={searchStore}
                  onChange={(e) => setSearchStore(e.target.value)}
                  fullWidth
                  sx={{
                    mb: 2,
                    '& .MuiInputBase-root': {
                      paddingBottom: '0.45rem'
                    },
                    '& input': {
                      paddingBottom: 0,
                      fontSize: '12px'
                    }
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchSVG />
                      </InputAdornment>
                    )
                  }}
                />
              </div>
              {FilSearchStore(stores)?.map((store) => (
                <DropdownStoreItem
                  key={store.store_id}
                  channelId={store.channel_id}
                  label={store.store_name}
                  item={store}
                  isItem={true}
                  onClick={() => {
                    setSelected(store);
                    setOpen(false);
                  }}
                />
              ))}
            </div>
          </ClickAwayListener>
        )}
      </Popper>
    </div>
  );
};